<mtg-button
  color="secondary"
  class="download-btn"
  leadingIcon="icons-cloud-download"
  [mtgDropdownTriggerFor]="files"
>
  Документы
</mtg-button>
<mtg-dropdown-menu #files>
  <mtg-dropdown-item (click)="printGameApplication()">Составы команд</mtg-dropdown-item>
  <mtg-dropdown-item (click)="printProtocol()">Протокол</mtg-dropdown-item>
</mtg-dropdown-menu>
